export class Dictionary<TValue> {
    private _hash: any = {};
    
    get keys(): any[] {
        return Object.keys(this._hash);
    }

    add(key: any, value: TValue) {
        if (!key) return;
        this._hash[key] = value;
    }

    get(id: any): TValue {
        return this._hash[id];
    }

    contains(id: any): boolean {
        return this.get(id) ? true : false;
    }

    remove(id: any) {
        delete this._hash[id];
    }

    clear() {
        this._hash = {};
    }

    values() :TValue[] {
        var values: TValue[] = [];
        for (let key of this.keys) {
            values.push(this.get(key));
        }
        return values;
    }

    static fromArray<TValue>(items: TValue[], keySelector: DictionaryKeySelector<TValue>) {
        var dict = new Dictionary<TValue>();
        items.forEach(item => dict.add(keySelector(item), item));
        return dict;
    }
}

export interface DictionaryKeySelector<T> {
    (item: T) : any
}
